import { Box, Icon, IconButton, InputChip, Menu } from '@zillow/constellation-10';
import { IconFilterFilled } from '@zillow/constellation-icons';

type Props = {
  isArchived: boolean;
  onArchivedChange: (isArchived: boolean) => void;
  isLoading?: boolean;
  testIdPrefix: string;
};

export const ArchivedFilterMenu = ({ isArchived, onArchivedChange, isLoading = false, testIdPrefix }: Props) => (
  <Menu.Root placement="bottom-start">
    <Menu.Trigger>
      <IconButton
        aria-label="Filters"
        title="Filters"
        tone="neutral"
        emphasis="bare"
        size="sm"
        disabled={isLoading}
        data-testid={`${testIdPrefix}-FiltersTrigger`}
      >
        <Icon render={<IconFilterFilled />} />
      </IconButton>
    </Menu.Trigger>
    <Menu.Portal>
      <Menu.Content>
        <Menu.Item
          role="menuitemcheckbox"
          aria-checked={isArchived}
          disabled={isLoading}
          onClick={() => onArchivedChange(!isArchived)}
          data-testid={`${testIdPrefix}-ArchivedToggle`}
        >
          <Menu.ItemLabel>Archived</Menu.ItemLabel>
        </Menu.Item>
      </Menu.Content>
    </Menu.Portal>
  </Menu.Root>
);

export const ArchivedFilterChip = ({ isArchived, onArchivedChange, isLoading = false, testIdPrefix }: Props) => (
  <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
    <InputChip
      isOpen={isArchived}
      onClose={() => onArchivedChange(false)}
      disabled={isLoading}
      data-testid={`${testIdPrefix}-ArchivedChip`}
    >
      Archived
    </InputChip>
  </Box>
);
